import React, { useState, useEffect } from "react";
import "./DetailProfile.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faMapMarkerAlt,
  faRetweet,
  faEye,
  faComment,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faClipboard,
  faUsers,
  faUserPlus,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import {
  faSquareXTwitter,
  faInstagram,
  faTiktok,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const DetailProfile = () => {
  const { platform, username } = useParams(); // Get the platform and username from the URL
  const location = useLocation(); // Access the state passed via navigation
  const [profile, setProfile] = useState(null); // State to store the profile data
  const [activeTab, setActiveTab] = useState("about");
  const navigate = useNavigate(); // Use useNavigate for navigation

  useEffect(() => {
    // Get the profile data passed from the Profiling component
    if (location.state?.profile) {
      setProfile(location.state.profile);
    }
  }, [location.state]);

  const setPlatformColor = (platform) => {
    switch (platform) {
      case "twitter":
        return "#000000";
      case "facebook":
        return "#3b5998";
      case "instagram":
        return "linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)";
      case "tiktok":
        return "linear-gradient(45deg, #69C9D0, #9300C7)";
      default:
        return "#707070";
    }
  };

  const setPlatformIcon = (platform) => {
    switch (platform) {
      case "twitter":
        return faSquareXTwitter;
      case "instagram":
        return faInstagram;
      case "tiktok":
        return faTiktok;
      case "facebook":
        return faFacebook;
      default:
        return null;
    }
  };

  const handleBackClick = () => navigate("/profiling");

  if (!profile) {
    return <div>Loading...</div>; // Show a loading state until the profile data is loaded
  }

  const showTab = (tabId) => setActiveTab(tabId);

  return (
    <div className="DP-main">
      {/* Profile Header */}
      <div className="profile-header">
  <div
    className="color-strip"
    style={{ background: setPlatformColor(platform) }}
  >
    <FontAwesomeIcon
      icon={setPlatformIcon(platform)}
      className="platform-icon"
    />
    <span className="platform-text">
      {platform.charAt(0).toUpperCase() + platform.slice(1)}
    </span>
  </div>
  <div className="profile-info">
  <a 
    href={`https://${platform === 'facebook' ? 'facebook.com/' + profile.username : platform === 'twitter' ? 'twitter.com/' + profile.username : platform === 'instagram' ? 'instagram.com/' + profile.username : 'tiktok.com/@' + profile.username}`} 
    target="_blank" 
    rel="noopener noreferrer"
    style={{ textDecoration: 'none', color: '#000000' }} // Remove underline and set purple color
  >
    <img src={profile.imgSrc} alt="Profile" />
  </a>
  <div>
    <a 
      href={`https://${platform === 'facebook' ? 'facebook.com/' + profile.username : platform === 'twitter' ? 'twitter.com/' + profile.username : platform === 'instagram' ? 'instagram.com/' + profile.username : 'tiktok.com/@' + profile.username}`} 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: '#000' }} // Remove underline and set purple color
    >
      <h1>{profile.full_name}</h1>
    </a>
      <p>@{profile.username}</p>
      <div className="stats">
        <div className="stat">
          <FontAwesomeIcon icon={faClipboard} />
          <span>Posts</span>
          <strong>{profile.stats.posts}</strong>
        </div>
        <div className="stat">
          <FontAwesomeIcon icon={faUsers} />
          <span>Followers</span>
          <strong>{profile.stats.followers}</strong>
        </div>
        <div className="stat">
          <FontAwesomeIcon icon={faUserPlus} />
          <span>Following</span>
          <strong>{profile.stats.friends}</strong>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* Back Button */}
      <div className="back-button-container">
        <button className="back-button" onClick={handleBackClick}>
          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </button>
      </div>

      {/* Tabs */}
      <div className="profile-nav">
        {/* Common tab for all platforms */}
        <button
          className={`tab-button ${activeTab === "about" ? "active" : ""}`}
          onClick={() => showTab("about")}
        >
          About
        </button>

        <button
          className={`tab-button ${activeTab === "posts" ? "active" : ""}`}
          onClick={() => showTab("posts")}
        >
          Posts
        </button>

        {/* Tabs for other platforms */}
        {platform !== "twitter" && (
          <>
            <button
              className={`tab-button ${
                activeTab === "followers" ? "active" : ""
              }`}
              onClick={() => showTab("followers")}
            >
              Followers
            </button>
            <button
              className={`tab-button ${
                activeTab === "following" ? "active" : ""
              }`}
              onClick={() => showTab("following")}
            >
              Following
            </button>
            
            {/* <button
              className={`tab-button ${
                activeTab === "Posts" ? "active" : ""
              }`}
              onClick={() => showTab("Posts")}
            >
              Posts
            </button> */}
          </>
        )}
      </div>

      {/* About Tab */}
      {activeTab === "about" && (
        <div className="tab-content about-grid">
          <div className="section bio">
            <h2>Bio</h2>
            <p>
              <strong>Name:</strong> {profile.full_name}
            </p>
            <p>
              <strong>About:</strong>{" "}
              {profile.description || "No description available"}
            </p>
          </div>

          <div className="section contact-info">
            <h2>Contact Info</h2>
            <p>
              <strong>Email:</strong>{" "}
              {profile.public_email ||
                profile.biography_link ||
                profile.email ||
                "N/A"}
            </p>
            <p>
              <strong>Address:</strong>{" "}
              {profile.location || profile.based_in || "N/A"}
            </p>
          </div>
        </div>
      )}

      {/* Followers Tab */}
      {activeTab === "followers" && (
        <div className="tab-content followers-grid">
          {profile?.followers?.length > 0 ? (
            profile.followers.map((follower, index) => (
              <div className="followers-card" key={index}>
                <div className="follow-card-header">
                  <img
                    src={
                      follower.profile_image_url ||
                      follower.profile_photo_thumb_big_url ||
                      follower.profile_avatar_url ||
                      follower.profile_photo_url ||
                      follower.avatar_url
                    }
                    alt="Profile"
                  />
                  <div>
                    <h3>{follower.full_name}</h3>
                    <p>@{follower.username}</p>
                  </div>

                  
                </div>
                <div className="card-location">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <span>
                    {follower.location ||
                      follower.hometown ||
                      follower.address ||
                      "Not Available"}
                  </span>
                </div>
                <div className="card-stats">
                  <span>
                    <FontAwesomeIcon icon={faClipboard} />{" "}
                    {follower.posts_count || follower.video_count || "N/A"}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faUsers} />{" "}
                    {follower.followers_count ||
                      follower.follower_count ||
                      "N/A"}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faUserPlus} />{" "}
                    {follower.following_count ||
                      follower.followings_count ||
                      "N/A"}
                  </span>
                  {/* Add this inside the "card-stats" div */}
                  <div className="card-link">
                    <button
                      className="profile-link-button"
                      onClick={() =>
                        window.open(
                          profile.platform === "facebook"
                            ? `https://facebook.com/${follower.id}`
                            : profile.platform === "instagram"
                            ? `https://instagram.com/${follower.id}`
                            : profile.platform === "twitter"
                            ? `https://twitter.com/${follower.id}`
                            : profile.platform === "tiktok"
                            ? `https://tiktok.com/@${follower.id}`
                            : "#",
                          "_blank"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No followers data available</p>
          )}
        </div>
      )}

      {/* Following Tab */}
      {activeTab === "following" && (
        <div className="tab-content following-grid">
          {profile?.following?.length > 0 ? (
            profile.following.map((following, index) => (
              <div className="following-card" key={index}>
                <div className="follow-card-header">
                  <img
                    src={
                      following.profile_image_url ||
                      following.profile_photo_thumb_big_url ||
                      following.profile_avatar_url ||
                      following.profile_photo_url ||
                      following.avatar_url
                    }
                    alt="Profile"
                  />
                  <div>
                    <h3>{following.full_name}</h3>
                    <p>@{following.username}</p>
                  </div>
                 
                </div>
                <div className="card-location">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  <span>
                    {following.location ||
                      following.hometown ||
                      following.address ||
                      "Not Available"}
                  </span>
                </div>
                <div className="card-stats">
                  <span>
                    <FontAwesomeIcon icon={faClipboard} />{" "}
                    {following.posts_count ||
                      following.video_count ||
                      following.statuses_count ||
                      "N/A"}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faUsers} />{" "}
                    {following.followers_count ||
                      following.follower_count ||
                      "N/A"}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faUserPlus} />{" "}
                    {following.following_count ||
                      following.followings_count ||
                      "N/A"}
                  </span>
                  {/* Add this inside the "card-stats" div */}
                  <div className="card-link">
                    <button
                      className="profile-link-button"
                      onClick={() =>
                        window.open(
                          profile.platform === "facebook"
                            ? `https://facebook.com/${following.id}`
                            : profile.platform === "instagram"
                            ? `https://instagram.com/${following.id}`
                            : profile.platform === "twitter"
                            ? `https://twitter.com/${following.id}`
                            : profile.platform === "tiktok"
                            ? `https://tiktok.com/@${following.id}`
                            : "#",
                          "_blank"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No following data available</p>
          )}
        </div>
      )}

      {/* Posts Tab */}
      {activeTab === "posts" && (
        <div className="tab-content posts-grid">
          {profile.posts?.length > 0 ? (
            profile.posts.map((post, index) => (
              <div className="post-card-unique" key={index}>
                <div className="post-header">
                  <img src={profile.imgSrc} alt="Profile" />
                  <div>
                    <h3>{profile.full_name}</h3>
                    <p>@{profile.username}</p>
                  </div>
                  {/* New Button for Post Link */}
                  <div className="post-link">
                    <button
                      className="post-link-button"
                      onClick={() =>
                        window.open(
                          platform === "instagram"
                            ? `https://instagram.com/p/${post.shortcode}`
                            : platform === "facebook"
                            ? `https://www.facebook.com/${post.id}`
                            : platform === "twitter"
                            ? `https://twitter.com/${post.author_id}/status/${post.id}`
                            : platform === "tiktok"
                            ? `https://tiktok.com/@${post.author_username}/video/${post.id}`
                            : "#",
                          "_blank"
                        )
                      }
                    >
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </button>
                  </div>
                </div>
                <div className="post-content">
                  <p>{post.text}</p>
                </div>
                {post.attached_medias_url &&
                  post.attached_medias_url.length > 0 && (
                    <div className="post-media">
                      {post.attached_medias_url.map((url, index) => (
                        <img key={index} src={url} alt={`Media ${index + 1}`} />
                      ))}
                    </div>
                  )}

                <div className="post-footer">
                  <div className="post-stats">
                    {/* Display stats based on platform */}
                    {platform === "twitter" && (
                      <>
                        <span>
                          <FontAwesomeIcon icon={faHeart} />{" "}
                          {post.favorite_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faComment} />{" "}
                          {post.reply_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faRetweet} />{" "}
                          {post.retweet_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faEye} /> {post.view_count}
                        </span>
                      </>
                    )}

                    {platform === "instagram" && (
                      <>
                        <span>
                          <FontAwesomeIcon icon={faHeart} /> {post.likes_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faComment} />{" "}
                          {post.comments_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faEye} />{" "}
                          {post.views_count ||
                            post.video_views_count ||
                            post.video_plays_count}
                        </span>
                      </>
                    )}

                    {platform === "facebook" && (
                      <>
                        <span>
                          <FontAwesomeIcon icon={faHeart} />{" "}
                          {post.reactions_like_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faComment} />{" "}
                          {post.comments_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faRetweet} />{" "}
                          {post.shares_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faEye} />{" "}
                          {post.views_count ||
                            post.video_view_count ||
                            post.reactions_total_count}
                        </span>
                      </>
                    )}

                    {platform === "tiktok" && (
                      <>
                        <span>
                          <FontAwesomeIcon icon={faHeart} /> {post.digg_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faComment} />{" "}
                          {post.comment_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faRetweet} />{" "}
                          {post.share_count}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faEye} /> {post.play_count}
                        </span>
                      </>
                    )}
                  </div>

                  <div className="post-timestamp">
                    {new Date(post.timestamp * 1000).toLocaleString("en-PK", {
                      timeZone: "Asia/Karachi",
                    })}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No posts available</p>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailProfile;
